/**
 * Las secciones del super admin y sus rutas: una sola tabla para el menú (`SuperAdminNavigation`) y para
 * la página (`SuperAdminPage`), que decide qué muestra con la misma regla que el menú marca.
 */
export const SUPER_ADMIN_ROUTES = {
  negocio: '/admin',
  clientes: '/admin/clientes',
  /** A quién invitó Smarty y en qué quedó cada invitación (founder, 30-sep). */
  invitaciones: '/admin/invitaciones',
  /** Los drops que se registraron solos: de dónde vino cada uno, y aprobarlos (5-oct). */
  altas: '/admin/altas',
  planes: '/admin/planes',
  propuestas: '/admin/propuestas',
  /** Lo que sacamos del menú del cliente porque todavía no está construido. */
  sinConstruir: '/admin/sin-construir',
  integraciones: '/admin/integraciones',
  configuracion: '/admin/configuracion',
} as const;

export type SuperAdminSection = keyof typeof SUPER_ADMIN_ROUTES;

export const SECTION_TITLES: Record<SuperAdminSection, string> = {
  negocio: 'Mi negocio',
  clientes: 'Clientes',
  invitaciones: 'Invitaciones',
  altas: 'Altas',
  planes: 'Planes',
  propuestas: 'Propuestas',
  sinConstruir: 'Sin construir',
  integraciones: 'Integraciones',
  configuracion: 'Configuración',
};

/**
 * La sección que muestra una URL: la que tiene la ruta más larga que la contiene (`/admin` es prefijo de
 * todas, así que es la de descarte). Una sola regla para el menú y para `SuperAdminPage`.
 */
export function seccionDeLaRuta(pathname: string): SuperAdminSection {
  const path = (pathname || '/admin').replace(/\/+$/, '') || '/admin';
  const [seccion] = (Object.entries(SUPER_ADMIN_ROUTES) as [SuperAdminSection, string][])
    .filter(([, url]) => path === url || path.startsWith(url + '/'))
    .sort(([, a], [, b]) => b.length - a.length);
  return seccion?.[0] ?? 'negocio';
}
